<template>
  <div class="modal" :class="{ 'd-block': showModal }" id="productModal" tabindex="-1" role="dialog"
       aria-labelledby="productModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document" style="maxWidth: 900px;">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="productModalLabel">
            Статистика клиента</h5>
          <b-button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
            <span aria-hidden="true">&times;</span>
          </b-button>
        </div>
        <div class="modal-body">
          <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
            <div v-if="this.orderDataIsLoading">
              <CircleProgress/>
            </div>
          </transition>
          <div v-for="order in this.clientOrders" :key="order.id">
            <div style="margin-top: 16px;">НОМЕР ДОГОВОРА: {{order.id}}</div>
            <div style="margin-top: 16px; display: flex; justify-content: space-between; align-items: center">
              <div>ДАТА ВЫДАЧИ: {{new Date(order.rentStartDate).toLocaleDateString('ru-RU', {day: '2-digit', month: '2-digit', year: 'numeric'})}}</div>
              <div>ДАТА ВОЗВРАТА: {{new Date(order.rentEndDate).toLocaleDateString('ru-RU', {day: '2-digit', month: '2-digit', year: 'numeric'})}}</div>
              <div>КОЛ-ВО ДНЕЙ: {{this.getDaysDifference(order.rentStartDate, order.rentEndDate)}}</div>

            </div>
                        <table class="products-preview">
              <thead>
              <tr>
                <th>Продукт</th>
                <th>Количество</th>
                <th>Скидка</th>
                <th>Цена</th>
                <th>Цена со скидкой</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in order.orderItems" :key="index">
                <td>{{ getProductNameById(item.productId) }}</td>
                <td>{{ item.quantity }}</td>
                <td>{{ item.discount }}%</td>
                <td>{{ getPriceWithoutDiscount(item.productId, item.quantity) }} BYN</td>
                <td>{{ getTotalPrice(item.productId, item.quantity, item.discount) }} BYN</td>
              </tr>
              </tbody>
            </table>
            <div class="sub-total" v-if="order.securityDepositAmount != null && order.securityDepositAmount != 0">ЗАЛОГ:
              {{
                order.securityDepositAmount.toFixed(2)
              }}
              BYN
            </div>
            <div class="sub-total" v-if="order.delivery != null && order.delivery != 0">ДОСТАВКА: {{
                order.delivery.toFixed(2)
              }}
              BYN
            </div>
            <div class="sub-total" v-if="order.sborka != null && order.sborka != 0">СБОРКА: {{
                order.sborka.toFixed(2)
              }}
              BYN
            </div>
            <div class="sub-total" v-if="order.ustanovka != null && order.ustanovka != 0">УСТАНОВКА: {{
                order.ustanovka.toFixed(2)
              }}
              BYN
            </div>
            <div style="margin-top: 16px;">ИТОГО: {{
                getTotalFinalPrice(order)
              }}
              BYN
            </div>
            <div style="margin-top: 8px;">С УЧЕТОМ СКИДКИ: {{ getTotalFinalDiscountPrice(order) }}
              BYN
            </div>
            <argon-button
                style="margin-top: 16px;"
                variant="fill"
                class="btn-primary btn"
                color="primary"
                type="submit"
                @click="showRepeatModal(order)"
            >Повторить
            </argon-button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <OrderEditorModal
      :show="showOrderModal"
      :order-id="null"
      :repeat-order="selectedOrderForRepeat"
      @close="closeOrderModal"
      @saved="closeOrderModal"
  />
</template>

<script>

import CircleProgress from "../CircleProgress.vue";
import velocity from "velocity-animate";
import axios from "@/axios";
import ArgonButton from "@/components/ArgonButton.vue";
import OrderEditorModal from "@/views/components/Form/OrderEditorModal.vue";

export default {
  name: "ClientOrderStatistic",
  components: {
    OrderEditorModal,
    ArgonButton,
    CircleProgress
  },
  props: {
    client: Object
  },
  data() {
    return {
      products: [],
      showOrderModal: null,
      editingOrderId: null,
      selectedOrderForRepeat: null,
      formErrors: {
        name: false,
        equipmentCost: false,
        rentCost: false,
        qty: false
      },
    };
  },
  computed: {
    showModal: {
      get() {
        return this.$store.state.clientsOrdersModal;
      },
    },
    orderDataIsLoading: {
      get() {
        return this.$store.state.orderViewProductsIsLoading;
      },
    },
    clientOrders: {
      get() {
        return this.$store.state.clientOrders;
      },
    },
    clientData: {
      get() {
        return this.$store.state.clientOrderStatisticItem;
      },
    }
  },
  methods: {
    beforeEnter(el) {
      el.style.opacity = 0;
    },
    enter(el, done) {
      velocity(el, {opacity: 1}, {duration: 500, complete: done});
    },
    leave(el, done) {
      velocity(el, {opacity: 0}, {duration: 500, complete: done});
    },
    fetchProducts() {
      let url = '/api/product';
      axios.get(url).then(response => {
        this.products = response.data;
      }).catch(error => {
        console.error("Ошибка загрузки данных: ", error);
      });
    },
    showEditOrderModal(order) {
      this.editingOrderId = order?.id;
      this.showOrderModal = true;
    },
    closeOrderModal() {
      this.showOrderModal = false;
      this.editingOrderId = null;
      this.selectedOrderForRepeat = null;
    },
    getOrderTotalPrice() {
      console.log("ORDERS IN MODAL: ", this.clientProducts)
      let totalPrice = 0;
      for (let i = 0; i < this.clientProducts.length; i++) {
        totalPrice += Number(this.getTotalPrice(this.clientProducts[i].productId, this.clientProducts[i].quantity, this.clientProducts[i].discount));
      }
      return totalPrice.toFixed(2);
    },
    getProductNameById(id) {
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].id == id) {
          return this.products[i].name;
        }
      }
      return 'Продукт не найден';
    },
    getTotalPrice(id, count, discount) {
      const price = this.getProductPriceById(id);
      let totalPrice = count * price;
      if (discount !== 0) {
        totalPrice = totalPrice * (1 - discount / 100);
      }
      totalPrice = totalPrice.toFixed(2);
      return totalPrice;

    },
    getPriceWithoutDiscount(id, count) {
      const price = this.getProductPriceById(id);
      let totalPrice = count * price;
      totalPrice = totalPrice.toFixed(2);
      return totalPrice;
    },
    getOrderTotalPriceWithoutDiscount() {
      let totalPrice = 0;
      for (let i = 0; i < this.clientProducts.length; i++) {
        totalPrice += Number(this.getPriceWithoutDiscount(this.clientProducts[i].productId, this.clientProducts[i].quantity));
      }
      return totalPrice.toFixed(2);
    },
    getProductPriceById(id) {
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].id == id) {
          return this.products[i].rentCost;
        }
      }
      return 0;
    },
    getDaysDifference(date1, date2) {
      const d1 = new Date(date1);
      const d2 = new Date(date2);

      const diffInMilliseconds = Math.abs(d2 - d1);
      const diffInDays = Math.ceil(diffInMilliseconds / (1000 * 60 * 60 * 24));

      return diffInDays;
    },
    setShowModal(active) {
      this.$store.commit('updateClientsOrdersModal', active);
    },
    setIsLoading(active) {
      this.$store.commit('updateOrderViewDataIsLoading', active);
    },
    clearViewData() {
      this.$store.commit('updateClientOrders', []);
    },
    closeModal() {
      this.setShowModal(false);
      // this.clearViewData();
    },
    getTotalFinalPrice(order) {
      let total = order.paymentAmount;
      total = total.toFixed(2);
      return total;
    },
    getTotalFinalDiscountPrice(order) {
      let total = order.endPrice;
      total = total.toFixed(2);
      return total;
    },
    showRepeatModal(order) {
      this.selectedOrderForRepeat = order;
      this.editingOrderId = null;
      this.showOrderModal = true;
    },
  },
  mounted() {
    this.setIsLoading(true);
    this.fetchProducts();
    this.setIsLoading(false);
  }
}


</script>

<style scoped>


.products-preview {
  margin-top: 16px;
  width: 100%;
}

td, th {
  width: auto;
  font-size: 0.8rem;
}

.sub-total {
  margin-top: 8px;
  font-size: 0.8rem;
  font-weight: 600;
}

</style>